<mat-card>
  <form [formGroup]="">
    <div fxLayout="column" fxLayoutGap="20px">

      <div class="status-info">
        <mat-form-field appearance="fill" [ngClass]="'input-color-' + participantObject?.status?.color">
          <mat-label>Status</mat-label>
          <input matInput placeholder="Status" [disabled]="true" [value]="participantObject?.status?.name">
        </mat-form-field>
      </div>

      <div *ngIf="profile?.userId" fxLayout="row" fxLayoutGap="15px">
        <button
          [disabled]="!((userPermissions | async)?.marketing?.write)"
          (click)="modify()"
          mat-stroked-button
          color="primary">
          <mat-icon>create</mat-icon>
          <span> Edytuj</span>
        </button>

        <button
          *ngIf="participantObject?.warehouseProduct?.protocol && participantObject?.competitionWz"
          (click)="generateProtocols()"
          mat-stroked-button
          color="primary">
          <span> Wygeneruj protokół </span>
        </button>
      </div>

      <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="start">

        <div fxFlex="50" fxLayout="column" fxLayoutGap="15px">

          <mat-card>
            <div fxFlex="100" fxLayout="column" fxLayoutGap="15px">
              <h3>Nagroda</h3>
              <app-detail
                header="Nagroda przypisana po ID"
                [value]="participantObject?.warehouseProduct?.productName"
                [link]="participantObject?.warehouseProduct?.uuid
                ? ['/stan-magazynowy/szczegoly', participantObject?.warehouseProduct?.uuid]
                : undefined">
              </app-detail>
              <app-detail
                header="Nagroda (dane z pliku)"
                [value]="participantObject?.product">
              </app-detail>
              <app-detail
                header="Liczba"
                [value]="participantObject?.amount?.toString()">
              </app-detail>

              <app-detail-bool header="Wymagany protokół"
                               [value]="participantObject?.warehouseProduct?.protocol">
              </app-detail-bool>

              <app-detail-bool header="Podpisany protokół"
                               [value]="participantObject?.protocolSigned">
              </app-detail-bool>

              <app-detail fxFlex="100" header="Wydanie"
                          [value]="participantObject?.competitionWz?.number"
                          [link]="participantObject?.competitionWz?.uuid
                ? ['/wydania-z-magazynu/szczegoly', participantObject?.competitionWz?.uuid]
                : undefined">
              </app-detail>
            </div>
          </mat-card>

          <mat-card>
            <div fxFlex="100" fxLayout="column" fxLayoutGap="15px">
              <h3>Struktura</h3>

              <app-detail
                *ngIf="participantObject?.ofwca && !(!participantObject?.partner && participantObject?.competitionImport?.partner)"
                header="OFWCA"
                [value]="participantObject?.ofwca?.fullName"
                [link]="participantObject?.ofwca?.uuid ? ['/ofwca/szczegoly', participantObject?.ofwca?.uuid] : undefined">
              </app-detail>

              <app-detail
                *ngIf="participantObject?.partner || (!participantObject?.partner && participantObject?.competitionImport?.partner)"
                header="Partner"
                [value]="participantObject?.partner?.shortName"
                [link]="participantObject?.partner?.uuid ? ['/partnerzy/szczegoly', participantObject?.partner?.uuid] : undefined">
              </app-detail>

              <app-detail
                *ngIf="participantObject?.ofwca || participantObject?.partner"
                header="Regionalny"
                [value]="participantObject?.partner?.assetsRegional?.fullName || participantObject?.ofwca?.assetsRegional?.fullName">
              </app-detail>
            </div>
          </mat-card>

        </div>

        <div fxFlex="50" fxLayout="column" fxLayoutGap="15px">

          <mat-card>
            <div fxFlex="100" fxLayout="column" fxLayoutGap="15px">
              <h3>Szczegóły</h3>
              <app-detail
                header="Konkurs"
                [value]="participantObject?.competitionImport?.competitionName">
              </app-detail>

              <app-detail
                *ngIf="participantObject?.competitionImport?.ofwca"
                header="Nagroda rozliczana na"
                [value]="'OFWCA'">
              </app-detail>
              <app-detail
                *ngIf="participantObject?.competitionImport?.partner"
                header="Nagroda rozliczana na"
                [value]="'Partner'">
              </app-detail>

              <app-detail
                *ngIf="participantObject?.competitionImport?.ofwca"
                header="Laureat"
                [value]="participantObject?.ofwca?.fullName"
                [link]="participantObject?.ofwca?.uuid ? ['/ofwca/szczegoly', participantObject?.ofwca?.uuid] : undefined">
              </app-detail>

              <app-detail
                *ngIf="participantObject?.competitionImport?.partner"
                header="Laureat"
                [value]="participantObject?.partner?.fullName"
                [link]="participantObject?.partner?.uuid ? ['/partnerzy/szczegoly', participantObject?.partner?.uuid] : undefined">
              </app-detail>

              <app-detail
                header="Miejsce w rankingu"
                [value]="participantObject?.ranking">
              </app-detail>
            </div>
          </mat-card>

        </div>

      </div>
    </div>
  </form>
</mat-card>
